module.exports = __webpack_public_path__ + "static/012-slideshow-490a3ce32a9b65c82c999050ff767961.jpg";